import { render, staticRenderFns } from "./PpvDiseaseFilter.vue?vue&type=template&id=370c7702&scoped=true"
import script from "./PpvDiseaseFilter.vue?vue&type=script&lang=js"
export * from "./PpvDiseaseFilter.vue?vue&type=script&lang=js"
import style0 from "./PpvDiseaseFilter.vue?vue&type=style&index=0&id=370c7702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370c7702",
  null
  
)

export default component.exports